export enum PolicyBenefits {
  VetFees = 'Vet Fees',
  Excess = 'Excess',
  DeathFromAccident = 'Death from Accident',
  ThirdPartyLiabilityDogsOnly = 'Third Party Liability (Dogs Only)',
  DentalTreatmentAccidentOnly = 'Dental Treatment (Accident only)',
  CtAndMriScans = 'CT & MRI Scans',
  DeathFromIllness = 'Death from Illness',
  BoardingFees = 'Boarding Fees',
  TheftOrStraying = 'Theft / Straying',
  HolidayCancellation = 'Holiday Cancellation',
  AdvertisingAndReward = 'Advertising & Reward',
  LossOfPetPassport = 'Loss of Pet Passport',
  OverseasTravel = 'Overseas Travel',
  Quarantine = 'Quarantine',
  EmergencyExpensesCoverAbroad = 'Emergency Expenses Cover Abroad',
  AccidentalDamage = 'Accidental Damage',
  VetHelpline = 'Vet Helpline',
}

export function isPolicyBenefit(policyBenefitCandidate: string): policyBenefitCandidate is PolicyBenefits {
  return policyBenefitCandidate in PolicyBenefits;
}
